export const INSTANCE_EATD_READ_STATISTICS_REQUEST = 'INSTANCE_EATD_READ_STATISTICS_REQUEST';
export const INSTANCE_EATD_READ_STATISTICS_SUCCESS = 'INSTANCE_EATD_READ_STATISTICS_SUCCESS';
export const INSTANCE_EATD_READ_STATISTICS_FAILURE = 'INSTANCE_EATD_READ_STATISTICS_FAILURE';
export const INSTANCE_EATD_READ_STATISTICS = [INSTANCE_EATD_READ_STATISTICS_REQUEST, INSTANCE_EATD_READ_STATISTICS_SUCCESS, INSTANCE_EATD_READ_STATISTICS_FAILURE];

export const INSTANCE_EATD_OPTIONS_READ_META_REQUEST = 'INSTANCE_EATD_OPTIONS_READ_META_REQUEST';
export const INSTANCE_EATD_OPTIONS_READ_META_SUCCESS = 'INSTANCE_EATD_OPTIONS_READ_META_SUCCESS';
export const INSTANCE_EATD_OPTIONS_READ_META_FAILURE = 'INSTANCE_EATD_OPTIONS_READ_META_FAILURE';
export const INSTANCE_EATD_OPTIONS_READ_META = [INSTANCE_EATD_OPTIONS_READ_META_REQUEST, INSTANCE_EATD_OPTIONS_READ_META_SUCCESS, INSTANCE_EATD_OPTIONS_READ_META_FAILURE];

export const INSTANCE_EATD_TEST_OPERATOR_ADD_REQUEST = 'INSTANCE_EATD_TEST_OPERATOR_ADD_REQUEST';
export const INSTANCE_EATD_TEST_OPERATOR_ADD_SUCCESS = 'INSTANCE_EATD_TEST_OPERATOR_ADD_SUCCESS';
export const INSTANCE_EATD_TEST_OPERATOR_ADD_FAILURE = 'INSTANCE_EATD_TEST_OPERATOR_ADD_FAILURE';
export const INSTANCE_EATD_TEST_OPERATOR_ADD = [INSTANCE_EATD_TEST_OPERATOR_ADD_REQUEST, INSTANCE_EATD_TEST_OPERATOR_ADD_SUCCESS, INSTANCE_EATD_TEST_OPERATOR_ADD_FAILURE];

export const INSTANCE_EATD_TEST_OPERATOR_REMOVE = 'INSTANCE_EATD_TEST_OPERATOR_REMOVE';
export const INSTANCE_EATD_ANONYMIZE_OPERATOR_REQUEST = 'INSTANCE_EATD_ANONYMIZE_OPERATOR_REQUEST';
export const INSTANCE_EATD_ANONYMIZE_OPERATOR_SUCCESS = 'INSTANCE_EATD_ANONYMIZE_OPERATOR_SUCCESS';
export const INSTANCE_EATD_ANONYMIZE_OPERATOR_FAILURE = 'INSTANCE_EATD_ANONYMIZE_OPERATOR_FAILURE';
export const INSTANCE_EATD_ANONYMIZE_OPERATOR = [INSTANCE_EATD_ANONYMIZE_OPERATOR_REQUEST, INSTANCE_EATD_ANONYMIZE_OPERATOR_SUCCESS, INSTANCE_EATD_ANONYMIZE_OPERATOR_FAILURE];

export const INSTANCE_EATD_PREVIEW_OPERATOR_REQUEST = 'INSTANCE_EATD_PREVIEW_OPERATOR_REQUEST';
export const INSTANCE_EATD_PREVIEW_OPERATOR_SUCCESS = 'INSTANCE_EATD_PREVIEW_OPERATOR_SUCCESS';
export const INSTANCE_EATD_PREVIEW_OPERATOR_FAILURE = 'INSTANCE_EATD_PREVIEW_OPERATOR_FAILURE';
export const INSTANCE_EATD_PREVIEW_OPERATOR = [INSTANCE_EATD_PREVIEW_OPERATOR_REQUEST, INSTANCE_EATD_PREVIEW_OPERATOR_SUCCESS, INSTANCE_EATD_PREVIEW_OPERATOR_FAILURE];

export const INSTANCE_EATD_OPTIONS_UPDATE_REQUEST = 'INSTANCE_EATD_OPTIONS_UPDATE_REQUEST';
export const INSTANCE_EATD_OPTIONS_UPDATE_SUCCESS = 'INSTANCE_EATD_OPTIONS_UPDATE_SUCCESS';
export const INSTANCE_EATD_OPTIONS_UPDATE_FAILURE = 'INSTANCE_EATD_OPTIONS_UPDATE_FAILURE';
export const INSTANCE_EATD_OPTIONS_UPDATE = [INSTANCE_EATD_OPTIONS_UPDATE_REQUEST, INSTANCE_EATD_OPTIONS_UPDATE_SUCCESS, INSTANCE_EATD_OPTIONS_UPDATE_FAILURE];

// Constants for managing the list of test incidents
export const EATD_TEST_INCIDENT_ADD_REQUEST = 'EATD_TEST_INCIDENT_ADD_REQUEST';
export const EATD_TEST_INCIDENT_ADD_SUCCESS = 'EATD_TEST_INCIDENT_ADD_SUCCESS';
export const EATD_TEST_INCIDENT_ADD_FAILURE = 'EATD_TEST_INCIDENT_ADD_FAILURE';
export const EATD_TEST_INCIDENT_REMOVE = 'EATD_TEST_INCIDENT_REMOVE'; // Simple removal, likely no async needed

// Constants for applying changes to a specific test incident
export const EATD_TEST_INCIDENT_APPLY_REQUEST = 'EATD_TEST_INCIDENT_APPLY_REQUEST';
export const EATD_TEST_INCIDENT_APPLY_SUCCESS = 'EATD_TEST_INCIDENT_APPLY_SUCCESS';
export const EATD_TEST_INCIDENT_APPLY_FAILURE = 'EATD_TEST_INCIDENT_APPLY_FAILURE';

// Constants for managing the list of test changes
export const EATD_TEST_CHANGE_ADD_REQUEST = 'EATD_TEST_CHANGE_ADD_REQUEST';
export const EATD_TEST_CHANGE_ADD_SUCCESS = 'EATD_TEST_CHANGE_ADD_SUCCESS';
export const EATD_TEST_CHANGE_ADD_FAILURE = 'EATD_TEST_CHANGE_ADD_FAILURE';
export const EATD_TEST_CHANGE_REMOVE = 'EATD_TEST_CHANGE_REMOVE';

// Constants for applying changes to a specific test change
export const EATD_TEST_CHANGE_APPLY_REQUEST = 'EATD_TEST_CHANGE_APPLY_REQUEST';
export const EATD_TEST_CHANGE_APPLY_SUCCESS = 'EATD_TEST_CHANGE_APPLY_SUCCESS';
export const EATD_TEST_CHANGE_APPLY_FAILURE = 'EATD_TEST_CHANGE_APPLY_FAILURE';
